export const LOGO_PLACEHOLDER = 'https://vereine.oefb.at/Content/images/svg/logo-placeholder.svg';
export const WACKER_LOGO = 'https://fc-wacker-innsbruck.at/wp-content/uploads/2023/05/FCW_Wappen_NEU.png';

export function normalizeTeamName(name) {
  if (!name) return '';
  return String(name)
    .replace(/&amp;#x2F;/gi, '/')
    .replace(/&#x2F;/gi, '/')
    .replace(/&amp;/g, '&')
    .trim();
}

export function teamLogoFromMatch(match, side) {
  const url = side === 'home' ? match?.homeTeamLogoUrl : match?.awayTeamLogoUrl;
  const name = normalizeTeamName(side === 'home' ? match?.homeTeamName : match?.awayTeamName);
  if (url) return url;
  if (name === 'FC Wacker Innsbruck' || /wacker innsbruck/i.test(name)) {
    return WACKER_LOGO;
  }
  return LOGO_PLACEHOLDER;
}
